(function () {
    'use strict';

    angular.module("imApp").factory("productPicsService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductPictures: function (parms) {
                return $ihttp.post({
                    method: 1065,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
